import React from 'react';
import { Table } from '../../../components/table';
import styles from './../styles.module.scss';
import { height } from 'styled-system';

export type GroupsTableProps = {
    // tableWidth: number;
    groupList: any[];
    onGroupSelection: (arg0: any) => any;
};

export const GroupsTable: React.FC<GroupsTableProps> = ({ groupList, onGroupSelection }) => {


    return (
        <div className={styles['groupsTable']}>
            <Table.AutoSizer>
                {({ height, width }) => (
                    <Table
                        height={height}
                        rowHeight={42}
                        rowCount={groupList.length}
                        width={width}
                        headerHeight={42}
                        rowGetter={({ index }) => {
                            return groupList[index];
                          }}
                        onRowClick={({ rowData }) => onGroupSelection(rowData)}
                    >
                        <Table.Column
                            width={300}
                            dataKey="name"
                            label="Group Name"
                        />
                        {/* <Table.Column
                            width={100}
                            dataKey="usersCount"
                            label="Users Count"
                        /> */}
                    </Table>
                )}
            </Table.AutoSizer>
        </div>
    );
};
